import { render, staticRenderFns } from "./DealerGroupList.vue?vue&type=template&id=22672b2f&scoped=true&"
import script from "./DealerGroupList.vue?vue&type=script&lang=js&"
export * from "./DealerGroupList.vue?vue&type=script&lang=js&"
import style0 from "./DealerGroupList.vue?vue&type=style&index=0&id=22672b2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22672b2f",
  null
  
)

export default component.exports